import { render, staticRenderFns } from "./adchannelManager.vue?vue&type=template&id=60174892"
import script from "./adchannelManager.vue?vue&type=script&lang=js"
export * from "./adchannelManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports